<template>
  <div class="google-map">
    <a :href="mapUrl" target="_blank">
      <img v-if="staticMapUrl" :src="staticMapUrl" />
    </a>
  </div>
</template>

<script>
import queryString from 'query-string';

export default {
  props: {
    buildingName: {
      type: String,
    },
    lng: {      
      required: true,
    },
    lat: {      
      required: true,
    },
    pinScale: {
      type: Number,
      default: () => 1,
    },
  },
  data() {
    return {
      key: process.env.GOOGLE_MAP_API_KEY,
      width: 0,
      height: 0,
      size: '',
      icon: 'https://file.midlandici.com/mr/img/static/pin_building.png',
    };
  },
  computed: {
    staticMapUrl() {
      const initialUrl = 'https://maps.googleapis.com/maps/api/staticmap';
      const params = {
        center: `${this.lat},${this.lng}`,
        size: '640x450',
        scale: 2,
        markers: `icon:${this.icon}|scale:${this.pinScale}|${this.lat},${this.lng}`,
        key: this.key,
        style: [
          'feature:all|element:labels.text.fill|color:0x736c68',
          'feature:landscape.man_made|element:geometry.fill|color:0xebebeb',
          'feature:landscape.natural|element:all|visibility:on|color:0xd4e4d3',
          'feature:landscape.natural|element:labels|color:0x95b7ab|weight:0.54',
          'feature:poi|element:geometry.fill|visibility:on|color:0xe1e0e0',
          'feature:poi.park|element:geometry.fill|color:0xd4e4d3',
          'feature:road|element:geometry.fill|color:0xf5f5f5',
          'feature:road|element:geometry.stroke|color:0xe7e6e5|gamma:0.65|lightness:0',
          'feature:transit|element:labels.text|visibility:off',
          'feature:water|element:all|color:0xa2c6db',
          'feature:water|element:labels|color:0x87aec5',
        ],
      };
      const parsedParams = queryString.stringify(params);
      return `${initialUrl}?${parsedParams}`;
    },
    mapUrl() {
      const initialUrl = 'https://www.google.com/maps/search/';
      const params = {
        api: 1,
      };
      if (this.buildingName) {
        params.query = this.buildingName;
      } else {
        params.query = `${this.lat},${this.lng}`;
      }
      return `${initialUrl}?${queryString.stringify(params)}`;
    },
  },
};
</script>

<style scoped>
.google-map {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: gray;
}

.google-map img {
  width: 100%;
  height: 450px;
  object-fit: cover;
}
</style>
